import {TCustomIconKey, TIconKey} from "./index";

export namespace nsFa {

    export const CustomIcons = {
        'fa-anchor-invalid': ['fa-anchor', 'fa-times-circle'],
        'fa-bars-add': ['fa-bars', 'fa-plus'],
        'fa-bars-plus': ['fa-bars', 'fa-plus-circle'],
        'fa-bars-remove': ['fa-bars', 'fa-times'],
        'fa-comment-lock': ['fa-comment', 'fa-unlock-alt '],
        'fa-customer-config': ['fa-building', 'fa-cog'],
        'fa-database-process': ['fa-database', 'fa-chart-network'],
        'fa-department-add': ['fa-sitemap', 'fa-plus-circle'],
        'fa-department-user': ['fa-sitemap', 'fa-user'],
        'fa-download-anchor': ['fa-download', 'fa-anchor'],
        'fa-download-users': ['fa-download', 'fa-users'],
        'fa-eadm-manager': ['fa-user-tie', 'fa-puzzle-piece'],
        'fa-eadm-user': ['fa-user', 'fa-puzzle-piece'],
        'fa-edit-permissions': ['fa-id-card-alt', 'fa-pencil'],
        'fa-email-custom': ['fa-cog', 'fa-envelope'],
        'fa-email-manager': ['fa-user-tie', 'fa-envelope'],
        'fa-email-user': ['fa-user', 'fa-envelope'],
        'fa-employement': ['fa-user', 'fa-suitcase'],
        'fa-envelope-plus': ['fa-envelope', 'fa-plus-circle'],
        'fa-external-contact': ['fa-user', 'fa-cloud-download'],
        'fa-folder-tree-window': ['fa-folder-tree', 'fa-window-maximize'],
        'fa-form-template': ['fa-file-invoice', 'fa-tag'],
        'fa-function-alias': ['fa-brackets', 'fa-function'],
        'fa-import-filter': ['fa-cloud-download', 'fa-filter'],
        'fa-import-history': ['fa-cloud-download', 'fa-circle no-fg', 'fa-history'],
        'fa-import-users': ['fa-cloud-download', 'fa-user-circle'],
        'fa-last-sync': ['fa-repeat', 'fa-question-circle'],
        'fa-lock-cog': ['fa-lock', 'fa-cog'],
        'fa-lock-update': ['fa-lock', 'fa-circle no-fg', 'fa-redo fas no-bg'],
        'fa-manual-department': ['fa-sitemap', 'fa-tag'],
        'fa-manual-group': ['fa-users', 'fa-tag'],
        'fa-manual-user': ['fa-user', 'fa-tag'],
        'fa-manual-apiuser': ['fa-user-robot', 'fa-tag'],
        'fa-map-signs-id-card': ['fa-map-signs', 'fa-id-card-alt'],
        'fa-map-signs-pencil': ['fa-map-signs', 'fa-pencil'],
        'fa-map-signs-plus': ['fa-map-signs', 'fa-plus-circle'],
        'fa-map-signs-window': ['fa-map-signs', 'fa-window-maximize'],
        'fa-members': ['fa-users', 'fa-star'],
        'fa-message-flow': ['fa-envelope', 'fa-tag'],
        'fa-minus-cog': ['fa-minus-circle', 'fa-cog'],
        'fa-new-manual': ['fa-tag', 'fa-plus-circle'],
        'fa-new-password': ['fa-lock', 'fa-exclamation-circle'],
        'fa-object-raw': ['fa-file-alt', 'fa-info-circle'],
        'fa-permission-process': ['fa-id-card-alt', 'fa-chart-network'],
        'fa-plus-cog': ['fa-plus-circle', 'fa-cog'],
        'fa-process-edit': ['fa-chart-network', 'fa-pencil'],
        'fa-puzzle-piece-info': ['fa-puzzle-piece', 'fa-info-circle'],
        'fa-role-add': ['fa-id-card-alt', 'fa-plus-circle'],
        'fa-ruleset': ['fa-scroll', 'fa-check-circle'],
        'fa-ruleset-info': ['fa-scroll', 'fa-info-circle'],
        'fa-ruleset-rules': ['fa-scroll', 'fa-list-alt'],
        'fa-ruleset-add': ['fa-scroll', 'fa-plus-circle'],
        'fa-search-value': ['fa-search flip-x', 'fa-question-circle'],
        'fa-server-check-circle': ['fa-server', 'fa-check-circle'],
        'fa-server-lock': ['fa-server', 'fa-lock'],
        'fa-shapes-arrow-down': ['fa-shapes', 'fa-arrow-alt-down'],
        'fa-shapes-arrow-up': ['fa-shapes', 'fa-arrow-alt-up'],
        'fa-sitemap-hand-point-up': ['fa-sitemap', 'fa-hand-point-up'],
        'fa-sitemap-window': ['fa-sitemap', 'fa-window-maximize'],
        'fa-sms-manager': ['fa-user-tie', 'fa-comment-lines'],
        'fa-sms-user': ['fa-user', 'fa-comment-lines'],
        'fa-sync-bell': ['fa-repeat', 'fa-bell'],
        'fa-sync-check color': ['fa-sync', 'fa-check-circle'],
        'fa-sync-email': ['fa-repeat', 'fa-envelope'],
        'fa-sync-hourglass color': ['fa-sync', 'fa-hourglass'],
        'fa-sync-template': ['fa-repeat', 'fa-tag'],
        'fa-synccycle': ['fa-repeat', 'fa-list-alt'],
        'fa-syncstep': ['fa-repeat', 'fa-exclamation-circle'],
        'fa-tag-plus': ['fa-tag', 'fa-plus-circle'],
        'fa-tag-trash': ['fa-tag', 'fa-trash-alt'],
        'fa-template-config': ['fa-cog', 'fa-tag'],
        'fa-test-export': ['fa-cloud-upload', 'fa-question-circle'],
        'fa-test-import': ['fa-cloud-download', 'fa-question-circle'],
        'fa-text-cog': ['fa-file-alt', 'fa-cog'],
        'fa-user-external-link': ['fa-user', 'fa-external-link'],
        'fa-user-hand-point-up': ['fa-user', 'fa-hand-point-up'],
        'fa-user-info': ['fa-user', 'fa-info-circle'],
        'fa-user-key': ['fa-user', 'fa-key'],
        'fa-user-process': ['fa-user', 'fa-chart-network'],
        'fa-user-time': ['fa-user', 'fa-history'],
        'fa-users-hand-point-up': ['fa-users', 'fa-hand-point-up'],
        'fa-users-plus': ['fa-users', 'fa-plus-circle'],
        'fa-users-thrash': ['fa-users', 'fa-trash-alt'],
        'fa-process-design': ['fa-chart-network', 'fa-pencil-ruler'],
        'fa-globe-edit': ['fa-globe', 'fa-pencil'],
        'fa-cloud-user': ['fa-cloud', 'fa-user'],
        'fa-query-alias': ['fa-comment-exclamation', 'fa-asterisk'],
        'fa-fe-standard': ['fa-exclamation-square', 'fa-square fas no-fg', 'fa-desktop'],
        'fa-be-standard': ['fa-exclamation-square', 'fa-server'],
        'fa-cog-edit': ['fa-cog', 'fa-pencil'],
        'fa-empty-fe-cache': ['fa-window-maximize', 'fa-recycle'],
        'fa-empty-be-cache': ['fa-database', 'fa-recycle'],
        'fa-cog-check': ['fa-cog', 'fa-check-circle'],
        'fa-calendar-pencil': ['fa-calendar', 'fa-pencil'],
        'fa-server-move': ['fa-server', 'fa-arrow-square-right'],
        'fa-lock-undo': ['fa-lock', 'fa-undo '],
    };

    export function getCustomIcon(icon: TCustomIconKey): string {
        const str = CustomIcons[icon];
        const iconMain = str[0] ?? '';
        const ret: string[] = [iconMain];
        str.slice(1).forEach(str => {
            if (!str.includes('no-bg')) {
                ret.push(str + ' fa-rw fas sup-bg');
            }
            if (!str.includes('no-fg')) {
                ret.push(str + ' fa-rw sup-fg');
            }
        })
        return ret
            .map((iconClass) => i(iconClass))
            .join(' ')
            ;
    }

    export function i(icon: TIconKey): string {
        const parts = icon?.split(' ')
        const part = parts?.find(str => str in CustomIcons)
        if (part) {
            return `<span class="fa-layer fa-standard ${ifa(icon)}">${getCustomIcon(part as TCustomIconKey)}</span>`;
        } else {
            return `<i class="${ifa(icon)}" aria-hidden="true"></i>`;
        }
    }

    export function ifa(icon: TIconKey): string {
        if (!icon) {
            return '';
        }
        const css = icon.split(' ');
        // if css string doesn't contain 'fa|fas|far|fal|fad' we'll simply add 'far'
        const regExp = /(^fa[rsld]?(?!-)|(?:[^-])fa[rsld]?(?!-))/g;
        if (!regExp.test(icon)) {
            css.push('far');
        }
        const index = css.indexOf('fa-rw');
        if (index == -1) {
            css.push('fa-fw');
        } else {
            css.splice(index, 1);
        }
        return css.join(' ');
    }

}
